module.exports = __webpack_public_path__ + "img/receive-square-2.101397d0.svg";